import RecommendedAdvisoryActivities from './component'
export default RecommendedAdvisoryActivities
